import post1 from './post1';
import post2 from './post2';

export default [post1, post2];